import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import { DropdownMenuLabel } from 'components/DropdownMenu'
import { useLoginProvider } from 'hooks/useLoginProvider'

type Props = {
  username?: string
}

export const RedirectToLogin: FC<Props> = ({ username }) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'user_menu',
  })

  const { redirectToLogin } = useLoginProvider()

  return (
    <DropdownMenuLabel className="cursor-pointer" onClick={redirectToLogin}>
      {username || t('redirect_to_login')}
    </DropdownMenuLabel>
  )
}
